export default __webpack_public_path__ + "static/media/zombie-logo2.ac6d8ad9.webp";